
import awsConfig from 'config/aws.config'; // eslint-disable-line
import fetch from 'isomorphic-fetch';
import 'es6-promise';


import {
    CognitoUserPool,
} from 'amazon-cognito-identity-js';


const userPool = new CognitoUserPool(awsConfig.pool);
function getAccessToken() {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    if (user) {
      user.getSession((error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.getIdToken().getJwtToken());
        }
      });
    }
  });
}


export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const api = 'https://apidev.leancubes.com/myrecboard';

export function fetchJSON(url, method = GET, params = {}, body = {}, headers = {}) {
  let modifiedHeaders = {
    'Content-Type': 'application/json',
  };
  return getAccessToken().then((token) => {
    modifiedHeaders = Object.assign({}, modifiedHeaders, { Authorization: token }, headers);
    if (method === POST || method === PUT) {
      modifiedHeaders = Object.assign({}, modifiedHeaders, {
        'Content-Type': 'application/json',
        Accept: 'application/jsobgDesktopn',
      });
      return fetch(url, {
        method,
        headers: modifiedHeaders,
        params,
        body: JSON.stringify(body),
      }).then((response) => {
        if (response.ok) {
          return response.json();
        }
        const res = response.json();
        res.then(item => ({ error: item, err: false }));
        return res;
      });
    }
    return fetch(url, {
      method,
      headers: modifiedHeaders,
      params,
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
      const res = response.json();
      res.then(item => ({ error: item, err: false }));
      return res;
    });
  });
}
export function fetchPublicJSON(url, method = GET) {
  const modifiedHeaders = {
    'Content-Type': 'application/json',
  };
  return fetch(url, {
    method,
    headers: modifiedHeaders,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(response.json());
  });
}

export function fetchPublicCOACH(url, method = GET, body = {}) {
  const modifiedHeaders = {
    'Content-Type': 'application/json',
  };
  return fetch(url, {
    method,
    headers: modifiedHeaders,
    body: JSON.stringify(body),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(response.json());
  });
}




// WEBPACK FOOTER //
// ./src/common/utils/http.js